export default __webpack_public_path__ + "static/poster-c4de7a6930e3606bca834ff1ed09bdfd.jpg";